<div class="ziro-admin-page-content">
  <div class="pb-2">
    <div class="col-md-10 offset-md-1 animate__animated animate__fadeIn">
      <ziro-breadcrumbs>
        <ziro-breadcrumb-card-item>
          <div [innerHTML]="'tkey;pages.admin.application_logs.description' | escapeHtml"></div>
        </ziro-breadcrumb-card-item>
      </ziro-breadcrumbs>

      <ul class="list-group mb-3 border-rad-all-12 card-shadow">
        <li class="list-group-item">
          <div class="d-md-flex align-items-center justify-content-between d-block">
            <div>
              <h5>{{ 'tkey;pages.admin.application_logs.todays.title' | translate }}</h5>
              <p>{{ 'tkey;pages.admin.application_logs.todays.description' | translate }}</p>
            </div>
            <ziro-button
              class="download-btn"
              [dataAutomation]="'export-todays-logs-button'"
              (clicked)="getTodaysLogs()"
              [isDisabled]="todaysLogsIsDownloading"
              [isPending]="todaysLogsIsDownloading"
              [icon]="icons.DOWNLOAD"
              [iconPending]="icons.SAVING"
              [buttonStyle]="buttonStyle.OUTLINE_PRIMARY"
              [isFullWidth]="true"
              [label]="'tkey;pages.admin.application_logs.todays.button'"
            ></ziro-button>
          </div>
        </li>
        <li class="list-group-item bg-light">
          <div class="d-md-flex align-items-center justify-content-between d-block">
            <div>
              <h5>{{ 'tkey;pages.admin.application_logs.all.title' | translate }}</h5>
              <p>
                {{ 'tkey;pages.admin.application_logs.all.description' | translate }}
              </p>
            </div>
            <ziro-button
              class="download-btn"
              [dataAutomation]="'export-all-logs-button'"
              (clicked)="getAllLogs()"
              [isDisabled]="allLogsIsDownloading"
              [isPending]="allLogsIsDownloading"
              [icon]="icons.DOWNLOAD"
              [iconPending]="icons.SAVING"
              [buttonStyle]="buttonStyle.OUTLINE_PRIMARY"
              [isFullWidth]="true"
              [label]="'tkey;pages.admin.application_logs.all.button'"
            ></ziro-button>
          </div>
        </li>
        @if (isHostedEnabled && isProxyEnabled) {
          <li class="list-group-item">
            <div class="d-md-flex align-items-center justify-content-between d-block">
              <div>
                <h5 [innerHTML]="'tkey;pages.admin.application_logs.proxy.todays.title' | escapeHtml"></h5>
                <p>
                  {{ 'tkey;pages.admin.application_logs.proxy.todays.description' | translate }}
                </p>
              </div>
              <ziro-button
                class="download-btn"
                [dataAutomation]="'export-all-proxy-logs-button'"
                (clicked)="getAllProxyLogs()"
                [isDisabled]="allProxyLogsIsDownloading || !isProxyHealthy"
                tooltip="tkey;pages.admin.application_logs.proxy.all.button.disabled.tooltip"
                [isTooltipDisabled]="isProxyHealthy"
                [isPending]="allProxyLogsIsDownloading"
                [icon]="icons.DOWNLOAD"
                [iconPending]="icons.SAVING"
                [buttonStyle]="buttonStyle.OUTLINE_PRIMARY"
                [isFullWidth]="true"
                [label]="'tkey;pages.admin.application_logs.proxy.todays.button'"
              ></ziro-button>
            </div>
          </li>
          <li class="list-group-item bg-light">
            <div class="d-md-flex align-items-center justify-content-between d-block">
              <div>
                <h5 [innerHTML]="'tkey;pages.admin.application_logs.proxy.all.title' | escapeHtml"></h5>
                <p>
                  {{ 'tkey;pages.admin.application_logs.proxy.all.description' | translate }}
                </p>
              </div>
              <ziro-button
                class="download-btn"
                [dataAutomation]="'export-todays-proxy-logs-button'"
                (clicked)="getTodaysProxyLogs()"
                [isDisabled]="todaysProxyLogsIsDownloading || !isProxyHealthy"
                tooltip="tkey;pages.admin.application_logs.proxy.all.button.disabled.tooltip"
                [isTooltipDisabled]="isProxyHealthy"
                [isPending]="todaysProxyLogsIsDownloading"
                [icon]="icons.DOWNLOAD"
                [iconPending]="icons.SAVING"
                [buttonStyle]="buttonStyle.OUTLINE_PRIMARY"
                [isFullWidth]="true"
                [label]="'tkey;pages.admin.application_logs.proxy.all.button'"
              ></ziro-button>
            </div>
          </li>
        }
      </ul>
    </div>
  </div>
</div>
